import React from 'react'
import styled from 'styled-components'
import '../chapterAddEdit.css'
import { Popup } from '../../../../../components/Popup'
import { Box, Text } from '../../../../../designSystem'
import load from './loading.gif'

const LoaderDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 20px;
`

function VerifyForBadPublish({ verifyForBadPublish, setVerifyForBadPublish }) {
  const {
    show,
    loading,
    issue_type,
    publish_anyway,
    review_again,
    words = [],
    message,
  } = verifyForBadPublish
  return (
    <Popup
      show={show}
      close={() => {
        review_again('review_again')
        setVerifyForBadPublish({ show: false })
      }}
      loading
      renderActions={
        !loading ? (
          <>
            {issue_type === 'pause_publishing_highlight' && (
              <button
                className="action-button"
                type="button"
                onClick={() => publish_anyway('publish_anyway')}
              >
                Publish Anyway
              </button>
            )}
            <button
              className="action-button primary"
              type="button"
              onClick={() => {
                review_again('review_again')
                setVerifyForBadPublish({ show: false })
              }}
            >
              Ok, Let me review
            </button>
          </>
        ) : (
          <></>
        )
      }
    >
      {!loading && (
        <>
          <Box
            variant="flex"
            alignItems="center"
            mb={8}
            justifyContent="flex-start"
          >
            <Text variant="titleSecondary" style={{ color: 'red' }}>
              Please Note
            </Text>
          </Box>

          {message && (
            <Text variant="caption" lineHeight={1.8} fontWeight={500}>
              {message}
              <br /> click here for{' '}
              <a href="/content-and-community-guidelines" target="_blank">
                guidelines.
              </a>
              <br />
              {words.length > 0 &&
                `Some of the Problematic Words are: ${words.join(', ')}`}
            </Text>
          )}
          {!message && (
            <Text variant="caption" lineHeight={1.8} fontWeight={500}>
              `Your chapter has failed content review and will not be made live
              . Please review your content{' '}
              <a href="/content-and-community-guidelines" target="_blank">
                guidelines
              </a>{' '}
              and update to meet our content . Once updated, your chapter will
              be reviewed again. <br />
              {words.length > 0 &&
                `Some of the Problematic Words are: ${words.join(', ')}`}
            </Text>
          )}
        </>
      )}
      {loading && (
        <LoaderDiv>
          <img src={load} alt="Loading..." />
          <Text>
            Please Wait while we are processing your writing. It might take a
            few seconds. Don&apos;t close your browser or click anything on
            screen
          </Text>
        </LoaderDiv>
      )}
    </Popup>
  )
}

export default VerifyForBadPublish